import { render, staticRenderFns } from "./WatfordCity.vue?vue&type=template&id=1a46e714&scoped=true&"
import script from "./WatfordCity.vue?vue&type=script&lang=js&"
export * from "./WatfordCity.vue?vue&type=script&lang=js&"
import style0 from "./WatfordCity.vue?vue&type=style&index=0&id=1a46e714&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a46e714",
  null
  
)

export default component.exports